import React from "react";

const LinkIcon = ({ className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={className ? className : "w-[24px] h-[24px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="m11.377 8.628 4.079-4.08c1.032-1.032 2.865-1.032 3.898 0l.094.096c1.033 1.032 1.033 2.865 0 3.897l-1.423 1.423a1 1 0 0 0 1.415 1.415l1.422-1.423c1.814-1.814 1.814-4.913 0-6.727l-.094-.095c-1.814-1.813-4.913-1.813-6.727 0l-4.079 4.08a4.78 4.78 0 0 0 0 6.82 1 1 0 0 0 1.415-1.414c-1.128-1.127-1.128-2.865 0-3.992"
      ></path>
      <path
        fill="currentColor"
        d="M14.698 9.3a1 1 0 0 0-1.415 1.415c1.128 1.127 1.128 2.865 0 3.993L8.54 19.45c-1.032 1.032-2.865 1.032-3.898 0l-.094-.095c-1.033-1.033-1.033-2.866 0-3.898l2.087-2.087a1 1 0 0 0-1.415-1.414l-2.087 2.087c-1.813 1.813-1.813 4.913 0 6.726l.095.095c1.814 1.813 4.913 1.813 6.727 0l4.743-4.743a4.78 4.78 0 0 0 0-6.821"
      ></path>
    </svg>
  );
};

export default LinkIcon;
